import { uuidv7 } from 'uuidv7';
import { BudgetLocale } from '../api/budget-locale';
import { TableView } from '../api/budget-types';
import { AccountState, AccountType } from '../../account/api/account-types';
import { BudgetCurrency } from '../api/budget-currency';
export function createDefaultBudget(budgets) {
    const budgetId = uuidv7();
    const accounts = [
        {
            id: uuidv7(),
            budgetId: budgetId,
            name: 'Cash',
            type: AccountType.CASH,
            state: AccountState.ACTIVE,
            assignments: [],
            transactions: [],
            position: 0,
        },
    ];
    const categories = [
        {
            id: uuidv7(),
            budgetId: budgetId,
            name: 'Discretionary',
            notes: 'Common expenses that are a little more flexible than others.',
            position: 0,
        },
        {
            id: uuidv7(),
            budgetId: budgetId,
            name: 'Monthly Bills',
            notes: 'Monthly Bills',
            position: 1,
        },
        {
            id: uuidv7(),
            budgetId: budgetId,
            name: 'Scheduled Expenses',
            notes: 'Monthly Bills',
            position: 2,
        },
        {
            id: uuidv7(),
            budgetId: budgetId,
            name: 'Special Events',
            notes: 'Monthly Bills',
            position: 3,
        },
        {
            id: uuidv7(),
            budgetId: budgetId,
            name: 'Savings',
            notes: 'Savings',
            position: 4,
        },
    ];
    const buckets = [
        // Discretionary
        {
            id: uuidv7(),
            budgetId: budgetId,
            categoryId: categories[0].id,
            position: 0,
            name: 'Groceries',
            assignments: [],
        },
        {
            id: uuidv7(),
            budgetId: budgetId,
            categoryId: categories[0].id,
            position: 1,
            name: 'Dining Out',
            assignments: [],
        },
        {
            id: uuidv7(),
            budgetId: budgetId,
            categoryId: categories[0].id,
            position: 2,
            name: 'Clothing',
            assignments: [],
        },
        { id: uuidv7(), budgetId: budgetId, categoryId: categories[0].id, position: 3, name: 'Coffee', assignments: [] },
        { id: uuidv7(), budgetId: budgetId, categoryId: categories[0].id, position: 4, name: 'Gifts', assignments: [] },
        {
            id: uuidv7(),
            budgetId: budgetId,
            categoryId: categories[0].id,
            position: 5,
            name: 'Entertainment',
            assignments: [],
        },
        // Monthly Bills
        {
            id: uuidv7(),
            budgetId: budgetId,
            categoryId: categories[1].id,
            position: 0,
            name: 'Rent/Mortgage',
            assignments: [],
        },
        {
            id: uuidv7(),
            budgetId: budgetId,
            categoryId: categories[1].id,
            position: 1,
            name: 'Electric',
            assignments: [],
        },
        { id: uuidv7(), budgetId: budgetId, categoryId: categories[1].id, position: 2, name: 'Phone', assignments: [] },
        {
            id: uuidv7(),
            budgetId: budgetId,
            categoryId: categories[1].id,
            position: 3,
            name: 'Internet',
            assignments: [],
        },
        { id: uuidv7(), budgetId: budgetId, categoryId: categories[1].id, position: 4, name: 'Gas', assignments: [] },
        { id: uuidv7(), budgetId: budgetId, categoryId: categories[1].id, position: 5, name: 'Netflix', assignments: [] },
        { id: uuidv7(), budgetId: budgetId, categoryId: categories[1].id, position: 6, name: 'Spotify', assignments: [] },
        // Scheduled Expenses
        {
            id: uuidv7(),
            budgetId: budgetId,
            categoryId: categories[2].id,
            position: 0,
            name: 'Property Taxes',
            assignments: [],
        },
        {
            id: uuidv7(),
            budgetId: budgetId,
            categoryId: categories[2].id,
            position: 1,
            name: 'Home Insurance',
            assignments: [],
        },
        {
            id: uuidv7(),
            budgetId: budgetId,
            categoryId: categories[2].id,
            position: 2,
            name: 'Car Insurance',
            assignments: [],
        },
        {
            id: uuidv7(),
            budgetId: budgetId,
            categoryId: categories[2].id,
            position: 3,
            name: 'Life Insurance',
            assignments: [],
        },
        {
            id: uuidv7(),
            budgetId: budgetId,
            categoryId: categories[2].id,
            position: 4,
            name: 'Amazon Prime',
            assignments: [],
        },
        {
            id: uuidv7(),
            budgetId: budgetId,
            categoryId: categories[2].id,
            position: 5,
            name: 'Pest Control',
            assignments: [],
        },
        // Special Events
        {
            id: uuidv7(),
            budgetId: budgetId,
            categoryId: categories[3].id,
            position: 0,
            name: 'Christmas',
            assignments: [],
        },
        { id: uuidv7(), budgetId: budgetId, categoryId: categories[3].id, position: 1, name: 'Easter', assignments: [] },
        {
            id: uuidv7(),
            budgetId: budgetId,
            categoryId: categories[3].id,
            position: 2,
            name: 'Anniversary',
            assignments: [],
        },
        {
            id: uuidv7(),
            budgetId: budgetId,
            categoryId: categories[3].id,
            position: 3,
            name: "So & So's Wedding",
            assignments: [],
        },
        {
            id: uuidv7(),
            budgetId: budgetId,
            categoryId: categories[3].id,
            position: 4,
            name: "So & So's Birthday",
            assignments: [],
        },
        // Savings
        {
            id: uuidv7(),
            budgetId: budgetId,
            categoryId: categories[4].id,
            position: 0,
            name: 'Emergency Fund',
            assignments: [],
        },
        {
            id: uuidv7(),
            budgetId: budgetId,
            categoryId: categories[4].id,
            position: 1,
            name: 'Retirement',
            assignments: [],
        },
        {
            id: uuidv7(),
            budgetId: budgetId,
            categoryId: categories[4].id,
            position: 2,
            name: 'Rainy Day',
            assignments: [],
        },
        {
            id: uuidv7(),
            budgetId: budgetId,
            categoryId: categories[4].id,
            position: 3,
            name: 'Vacation',
            assignments: [],
        },
    ];
    return {
        id: budgetId,
        name: 'My Budget',
        currency: BudgetCurrency.USD,
        locale: BudgetLocale.EN_US,
        notes: '',
        position: budgets.length,
        settings: {
            tableView: TableView.ALL,
            collapsedCategoryIds: [],
            bucketProjections: {},
        },
        accounts,
        transactions: [],
        categories,
        buckets,
        views: [],
    };
}
